import { convertMoneyForDisplay, moneyToMajor, normalizeDisplayCurrency } from "./money";

const major = value => moneyToMajor(value) ?? 0;
const beforeVat = quote => major(quote.subtotal) + major(quote.deliveryRate) +
  major(quote.additionalFee) + major(quote.giftWrapping) - major(quote.discountTotal);

export const isQuoteVatIncluded = quote => major(quote?.vatAmount) > 0 &&
  Math.abs(major(quote.orderTotal) - beforeVat(quote)) < 0.000001;

// Each displayed component may be rounded to the merchant's conversion step.
// Reconcile that presentation-only difference; never alter the server total.
export const getQuoteDisplayRounding = (quote, displayValue, afterTenders = false) => {
  const display = normalizeDisplayCurrency(displayValue);
  if (!quote || !display?.converted || quote.pricingStatus === "pending") return null;
  const entries = [[quote.subtotal, 1], [quote.deliveryRate, 1], [quote.additionalFee, 1],
    [quote.giftWrapping, 1], [quote.discountTotal, -1]];
  if (!isQuoteVatIncluded(quote)) entries.push([quote.vatAmount, 1]);
  if (afterTenders) entries.push([quote.walletApplied, -1], [quote.pointsApplied, -1]);
  const target = afterTenders ? quote.total : quote.orderTotal;
  if (moneyToMajor(target) === null) return null;
  // Unknown fees must not be disguised as currency rounding.
  if (Math.abs(entries.reduce((sum, [value, sign]) => sum + major(value) * sign, 0) - major(target)) > 0.000001) return null;
  const scale = 10 ** display.fractionDigits;
  const minor = value => Math.round(major(convertMoneyForDisplay(value, display)) * scale);
  const difference = minor(target) - entries.reduce((sum, [value, sign]) => sum + minor(value) * sign, 0);
  return difference ? { amountMinor: difference, currency: display.currency, fractionDigits: display.fractionDigits } : null;
};
